var exports = {
  "kL": "x234b8571--6d4c58--container",
  "Qs": "x234b8571--6d4c58--content",
  "_K": "x234b8571--6d4c58--promo-types",
  "nf": "x234b8571--6d4c58--link",
};

module.exports = exports;
